<template>
  <div class="board">
    <div class="header">
      <p><span v-text="data.productionLineName"></span>生产状态看板</p>
      <p><span v-text="data.englishProductionLineName"></span> Assembly Status Kanban</p>
    </div>
    <div class="time">
      <div class="left">
        <div class="left_item">
          <div class="item_i">
            <p>计划产量</p>
            <p>Output</p>
          </div>
          <div class="item_value" v-text="data.planNumber"></div>
        </div>
        <div class="left_item">
          <div class="item_i">
            <p>实际产量</p>
            <p>Complete</p>
          </div>
          <div class="item_value" v-text="data.endNumber"></div>
        </div>
        <div class="left_item">
          <div class="item_i">
            <p>节拍时间</p>
            <p>Takt time</p>
          </div>
          <div class="item_value" v-text="data.beatTime"></div>
        </div>
        <div class="left_item">
          <div class="item_i">
            <p>剩余时间</p>
            <p>Remain</p>
          </div>
          <div v-if="data.stopped" class="item_value" style="color: #00ff00;" v-text="data.remaindTime"></div>
          <div v-if="!data.stopped" class="item_value" v-text="data.remaindTime"></div>
        </div>
      </div>
    </div>
    <div class="time">
      <div class="left">
        <div class="right_item">
          <div class="right_item_i number" v-text="data.year"></div>
          <div class="right_item_i key">
            <p>年</p>
            <p>Y</p>
          </div>
          <div class="right_item_i number" v-text="data.month"></div>
          <div class="right_item_i key">
            <p>月</p>
            <p>M</p>
          </div>
          <div class="right_item_i number" v-text="data.day"></div>
          <div class="right_item_i key">
            <p>日</p>
            <p>D</p>
          </div>
        </div>
        <div class="right_item" style="margin-left: 20px">
          <div class="right_item_i key">
            <p>星期</p>
            <p>Day</p>
          </div>
          <div class="right_item_i number" v-text="data.week"></div>
          <div class="right_item_i key">
            <p>时间</p>
            <p>Time</p>
          </div>
          <div class="right_item_i number" v-text="data.time"></div>
        </div>
      </div>
    </div>
    <el-table :data="data.tableData" style="width: 100%" border>
      <el-table-column>
        <template #header>
          <p style="line-height:30px; font-size:24px;">状态</p>
          <p style="line-height:30px; font-size:24px;">Status</p>
        </template>
        <template #default="scope">
          <div style="text-align: center; line-height:30px;">
            <span style="font-size: 22px;"> {{ scope.row.name }}<br/>{{ scope.row.EnglishName }} </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA01">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA01"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA02" v-if="data.stationList.length - data.specialStationCount > 1">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA02"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA03" v-if="data.stationList.length - data.specialStationCount > 2">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA03"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA04" v-if="data.stationList.length - data.specialStationCount > 3">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA04"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA05" v-if="data.stationList.length - data.specialStationCount > 4">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA05"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA06" v-if="data.stationList.length - data.specialStationCount > 5">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA06"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA07" v-if="data.stationList.length - data.specialStationCount > 6">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA07"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA08" v-if="data.stationList.length - data.specialStationCount > 7">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.FA08"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA09" v-if="data.stationList.length - data.specialStationCount > 8">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA09"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA10" v-if="data.stationList.length - data.specialStationCount > 9">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA10"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA11" v-if="data.stationList.length - data.specialStationCount > 10">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA11"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA12" v-if="data.stationList.length - data.specialStationCount > 11">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA12"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA13" v-if="data.stationList.length - data.specialStationCount > 12">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA13"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA14" v-if="data.stationList.length - data.specialStationCount > 13">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA14"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA15" v-if="data.stationList.length - data.specialStationCount > 14">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA15"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FA16" v-if="data.stationList.length - data.specialStationCount > 15">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center ">
            <span :class="scope.row.FA16"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="测试" v-if="data.testExist">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.测试"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="精整" v-if="data.finishingExist">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.精整"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="自检" v-if="data.selfTestExist">
        <template #default="scope">
          <div style="display: flex; align-items: center; justify-content: center">
            <span :class="scope.row.自检"></span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { reactive, onMounted, nextTick } from 'vue'
import axios from '@/utils/http'

const data = reactive({
  productionLineName: '',
  englishProductionLineName: '',
  remaindTime: '--:--',
  beatTime: '--:--',
  endNumber: 0,
  planNumber: 60,
  timeRemainMinutes: 0,
  timer: '',
  year: '',
  month: '',
  day: '',
  week: '',
  time: '',
  lineCode: '',
  stationList: [],
  tableData: [],
  stopped: false,
  showType: '黑色标准',
  specialStationCount: 0,
  testExist: false,
  finishingExist: false,
  selfTestExist: false
})

onMounted(() => {
  getParam()
  getSimpleLineInfo()
  data.timer = setInterval(getSimpleLineInfo, 5000)
})
const getParam = () => {
  const url = window.location.href
  const dzUrl = url.split('#')[0]
  const cs = dzUrl.split('?')[1]
  data.lineCode = cs.split('=')[1]
}
const getSimpleLineInfo = () => {
  axios.get('/api/board/getLineInfo/' + data.lineCode).then(res => {
    if (res.code === 200) {
      if (res.data.showType !== data.showType) {
        window.location.reload()
      }
      data.remaindTime = (res.data.timeRemainMinutes < 0 ? '-' : '') + res.data.timeRemain
      data.beatTime = res.data.beat
      data.endNumber = res.data.completeNumber
      data.planNumber = res.data.planNumber
      data.productionLineName = res.data.productionLineName
      data.englishProductionLineName = res.data.englishProductionLineName
      data.timeRemainMinutes = res.data.timeRemainMinutes
      data.time = res.data.time
      data.year = res.data.year
      data.stopped = res.data.stopped
      data.month = res.data.month
      data.day = res.data.day
      data.week = res.data.week
      data.stationList = res.data.stationList
      data.tableData = []
      data.specialStationCount = 0
      data.testExist = false
      data.selfTestExist = false
      data.finishingExist = false
      for (var k = 0; k < res.data.stationList.length; k++) {
        if (res.data.stationList[k].number === '测试' && data.testExist === false) {
          data.specialStationCount = data.specialStationCount + 1
          data.testExist = true
        }
        if (res.data.stationList[k].number === '精整' && data.finishingExist === false) {
          data.specialStationCount = data.specialStationCount + 1
          data.finishingExist = true
        }
        if (res.data.stationList[k].number === '自检' && data.selfTestExist === false) {
          data.specialStationCount = data.specialStationCount + 1
          data.selfTestExist = true
        }
      }
      for (var i = 0; i < res.data.statusDTOSList.length; i++) {
        const hr = {}
        hr.name = res.data.statusDTOSList[i].statusName
        hr.EnglishName = res.data.statusDTOSList[i].englishStatusName
        for (var j = 0; j < res.data.stationList.length; j++) {
          hr[res.data.stationList[j].number] = ''
          if (i === 0 && res.data.stationList[j].status[0] === 2) {
            hr[res.data.stationList[j].number] = 'green'
          }
          if (i === 2 && res.data.stationList[j].status[0] === 1) {
            hr[res.data.stationList[j].number] = 'yellow'
          }
          if (i === 1 && res.data.stationList[j].status[0] === 3) {
            hr[res.data.stationList[j].number] = 'darkGreen'
          }
          if (i === 3 && res.data.stationList[j].status[1] !== 0) {
            hr[res.data.stationList[j].number] = 'error'
          }
          if (i === 4 && res.data.stationList[j].status[2] !== 0) {
            hr[res.data.stationList[j].number] = 'error'
          }
          if (i === 6 && res.data.stationList[j].status[3] !== 0) {
            hr[res.data.stationList[j].number] = 'error'
          }
          if (i === 5 && res.data.stationList[j].status[4] !== 0) {
            hr[res.data.stationList[j].number] = 'error'
          }
        }
        data.tableData.push(hr)
      }
    }
  })
}
</script>
<style lang="scss">
.board {
  .error,
  .darkGreen,
  .yellow,
  .green{
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-weight: 700;
  }
  .error {
    background-color: #ff0000;
    color: #fff;
  }
  .darkGreen {
    background-color: #008200;
    color: #fff;
  }
  .yellow {
    background-color: #ffff00;
    color: #333;
  }
  .green {
    background-color: #00ff00;
    color: #fff;
  }
  .el-table{
    margin-top: 30px;
    // font-weight: 400;
    font-size: 22px;
  }
  .el-table th.el-table__cell, .el-table tr, .el-table, .el-table tr{
    background-color: transparent;
    color: #fff;
    font-weight: 500;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: transparent;
    color: #fff;
  }
  .el-table--border .el-table__cell:first-child .cell{
    text-align: center;
    font-size: 26px;
    line-height: 26px;
  }
  .el-table th.el-table__cell>.cell{
    text-align: center;
    font-size: 26px;
    line-height: 26px;
  }
  .el-table--border::after{
    right: 2px;
  }
}
</style>

<style lang="scss" scoped>
.board {
  width: 100%;
  height: 100%;
  padding: 40px 90px;
  color: white;
  background-color: #021F1F;
  .header {
    text-align: center;
    font-size: 42px;
    font-weight: 400;
  }
  .time{
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 30px;
    .left{
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      .left_item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 34px;
        text-align: center;
        font-weight: 500;
        margin-left: 10px;
        margin-right: 18px;
        .item_value{
          border: 2px solid #969696;
          width: 5.2em;
          font-size: 42px;
          padding: 0.4em 0;
          text-align: center;
          color: #f7ff00;
          margin-left: 36px;
        }
      }
    }
    .right_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 34px;
      text-align: center;
      text-align: center;
      font-weight: 500;
      .number{
        border: 2px solid #969696;
        color: #f7ff00;
        padding: 0.4em 54.5px;
        font-size: 42px;
      }
      .key{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 48px;
      }
    }
  }
}
</style>
